module.exports = __webpack_public_path__ + "static/helppes-a560f4364978dae509b1c1bd143c1114.png";